var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-data-members"},[_c('Avatar',{attrs:{"value":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }